import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function Hangars() {
  const [hangars, setHangars] = useState([]);
  useEffect(() => { api.get("/hangars").then((r) => setHangars(r.data)); }, []);

  return (
    <div data-testid="hangars-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 anim-fadeup">
      <div className="section-label">Hangars & Tie-Downs</div>
      <h1 className="font-display font-bold text-4xl sm:text-5xl text-slate-950 mt-3">Storage that fits the mission.</h1>
      <p className="mt-3 text-slate-600 max-w-2xl">
        T-hangars for single-engine piston, larger boxes for twins and turboprops, and a corporate hangar built for jets.
        Month-to-month leases — call ops to confirm availability.
      </p>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {hangars.map((h) => (
          <div key={h.id} data-testid={`hangar-${h.id}`} className="bg-white border border-slate-200 p-6 flex flex-col">
            <div className="flex items-center justify-between">
              <div className="text-xs font-mono uppercase tracking-widest text-sky-600">{h.size}</div>
              {h.available ? (
                <span className="inline-flex items-center gap-1 text-xs font-mono uppercase tracking-widest text-emerald-600">
                  <CheckCircle2 className="h-3.5 w-3.5" /> Call for Availability
                </span>
              ) : (
                <span className="inline-flex items-center gap-1 text-xs font-mono uppercase tracking-widest text-slate-400">
                  <XCircle className="h-3.5 w-3.5" /> Occupied
                </span>
              )}
            </div>
            <div className="font-display text-2xl font-semibold mt-3 text-slate-950">{h.name}</div>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{h.description}</p>
            <div className="mt-6 pt-4 border-t border-slate-200 flex items-end justify-between gap-3">
              {(/(corporate|community)/i).test(`${h.name} ${h.size}`) ? (
                <div>
                  <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Monthly</div>
                  <div className="font-display text-lg font-bold text-slate-950 leading-tight">Call for price /<br />availability</div>
                </div>
              ) : (
                <div>
                  <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Monthly</div>
                  <div className="font-display text-3xl font-bold text-slate-950">${h.monthly_rate.toFixed(0)}</div>
                </div>
              )}
              <a href="/contact" className="text-xs font-mono uppercase tracking-widest border border-slate-900 px-3 py-2 hover:bg-slate-900 hover:text-white transition-colors shrink-0">
                Inquire
              </a>
            </div>
          </div>
        ))}
        {hangars.length === 0 && <div className="text-slate-500">No hangars listed yet.</div>}
      </div>
    </div>
  );
}
